import {Component, OnInit} from '@angular/core';
import {DetectedCoreHostService} from './services/detected.core.host.service';
declare function require(moduleName: string): any;
const {version : appVersion} = require('../../appversion.json');
const {status : appStatus} = require('../../appversion.json');

@Component({
    selector: 'app-lora-root',
    templateUrl: 'lora-root.template.html',
    styleUrls: ['lora-root.styles.scss']
})

export class LoraRootComponent implements OnInit {
    public appVersion;
    constructor(public host: DetectedCoreHostService) {
        this.appVersion = 'v. ' + appVersion.major + '.' + appVersion.minor + '.' + appVersion.patch + ' ' + appStatus.stage;
        console.log(this.appVersion);  }

    ngOnInit () {
      this.host.setHost();
    }
 }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/lora-root.component.ts